class ApiSelections {
    constructor(Restangular, ApiBaseResponseService) {
        return {
            /**
             * Get all selections
             * @return {Object}
             */

            getSelectionsFiltered(filterObject) {
                return Restangular
                    .one('selections')
                    .get(filterObject)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * Get all selections
             * @return {Object}
             */
            getSelections() {
                return Restangular
                    .one('selections')
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
              Gets the selections that are purchasd by members of the team the user belongs to.
            */
            getPurchasedTeamSelections() {
                return Restangular
                    .one('selections/teamPurchased')
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * get the selection details
             * @param  {integer} selectionId
             * @return {Object}  selectionDetail object of the id provided as argumnent
             */
            getSelection(selectionId) {
                return Restangular
                    .one('selections', selectionId)
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             Get the selections with an existing license for the user
             */
            getSelectionsMinimal() {
                return Restangular
                    .one('selections/minimal')
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * get the children of a selection
             * @param  {integer} selectionId
             * @return {Object}  selectionDetail object of the id provided as argumnent
             */
            getSelectionChildren(selectionId) {
                return Restangular
                    .one('selections', selectionId)
                    .one('children')
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getSelectionsOfUser(userId) {
                return Restangular
                    .one('selections')
                    .one('user', userId)
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * post payment information
             * @return {Object}
             */
            purchaseByCC(payment) {

                for (let i = 0; i < payment.selectionsToPurchase.length; i++) {
                    delete payment.selectionsToPurchase[i].cost;
                    delete payment.selectionsToPurchase[i].selectionName;
                    delete payment.selectionsToPurchase[i].subtitle;
                    delete payment.selectionsToPurchase[i].icon;
                }

                var purchaseLicenceModel = {
                    'stripeOneTimeToken': payment.token,
                    'selectionsToPurchase': payment.selectionsToPurchase
                };

                return Restangular
                    .all('licenses')
                    .all('purchaseByCC')
                    .post(purchaseLicenceModel)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * post payment information
             * @return {Object}
             */
            purchaseByInvoice(selectionsToPurchase) {
                return Restangular
                    .all('licenses')
                    .all('purchaseByInvoice')
                    .post({ selectionsToPurchase })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * post user Ids
             * @return {Object}
             */
            removeLicenses(userIds, licenseId) {
                return Restangular
                    .one('licenses', licenseId)
                    .all('assignedUsers')
                    .remove(userIds)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * post user Ids
             * @return {Object}
             */
            assignLicenses(userIds, licenseId) {
                return Restangular
                    .one('licenses', licenseId)
                    .all('assignedUsers')
                    .post(userIds)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            verifyPrices(licenses) {
                licenses.forEach((item) => {
                    delete item.cost
                    delete item.selectionName;
                    delete item.subtitle;
                    delete item.icon;
                });
                return Restangular
                    .all('licenses')
                    .all('verifyPrices')
                    .post(licenses)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            }
        };
    }
}

ApiSelections.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiSelections;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiSelections.js
 **/